import React from 'react';
import { pdf, Font, Document, Page, Text, Image,View, StyleSheet } from '@react-pdf/renderer';
import cl from './Invoice.module.css'
import Attachment from "../../../../assets/Icon/Attachment"; 
import PDFicon from "../../../../assets/Icon/FileDollar";
import HelveticaBold from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-75Bd.ttf'; 
import HelveticaMd from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-65Md.ttf';
import AigLogo from '../../../../assets/Logo/Aig.png';


const formatDate = (dateString) => {

    const purchasedAtDate = new Date(dateString);

    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
     
    const day = purchasedAtDate.getDate();
    const month = months[purchasedAtDate.getMonth()];
    const year = purchasedAtDate.getFullYear();

    return `${day} ${month} ${year}`;
};

let primaryColor = "#000"

primaryColor = "#da0429" 

Font.register({
    family: 'HelveticaMd',  
    src: HelveticaMd, 
});

Font.register({
    family: 'HelveticaBold', 
    src: HelveticaBold, 
});


const styles = StyleSheet.create({

    page: {
        fontFamily: 'HelveticaMd', 
        backgroundColor: '#FFF',
        padding: 0,
    },

    header: {
        width: '90%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingTop: '50px',
        borderBottom: '4px solid #da0429',
        marginLeft:'30px'

    },

    invoiceBox: {
        color: '#fff',
        padding: '10px 10px 10px 0px',
    },

    invoiceText: {
        color: '#fff',
        fontSize: '22px',
        fontFamily: 'HelveticaBold',
    },

    invoiceDateAndId: {
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'center',
    },

    invoiceDate: {
        marginBottom: '2px',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'flex-end'
    },

    invoiceDateText: {
        fontSize: '13px',
        paddingRight: '5px',
        family: 'HelveticaBold', 
    },

    invoiceDateIDText: {
        fontSize: '13px',
        color: '#777',
    },

    invoiceNumber: {
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'flex-end'
    },

    invoiceNumberText: {
        fontSize: '13px',
        paddingRight: '5px',
        family: 'HelveticaBold',
    },

    invoiceNumberIDText: {
        fontSize: '13px',
        color: '#777',
    },

    invoiceToCompany: {
        marginTop: '40px',
        padding: '0 30px',
    },

    invoiceToCompanyBG: {
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        backgroundColor: '#eaeaea',
        padding: '20px 20px',
        boxShadow: '0px 10px 15px -3px rgba(0,0,0,0.1)'
 
    },

    invoiceTo: {
        width: '40%',
        borderRight: '2px solid '+ primaryColor,
    },
    invoiceCompany: {
        width: '60%',
        paddingLeft: '40px',
    },

    invoiceToHeader: { 
        fontSize: '16px',
        color: '#000',
        fontFamily: 'HelveticaBold',
        marginBottom: '8px',
        fontWeight: 'bold'
    },

    invoiceCompanyHeader: { 
        fontSize: '16px',
        color: '#000',
        fontFamily: 'HelveticaBold',
        marginBottom: '8px',
    },

    invoiceToName: { 
        fontSize: '12px',
        color: '#000',
        marginBottom: '6px',
    },

    invoiceCompanyName: { 
        fontSize: '13px',
        color: '#000',
        marginBottom: '6px',
    },




    invoiceParam: {
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'flex-end',
        marginBottom: '1px',
    },

    invoiceParamText: {
        width: '25px',
        maxWidth: '25px',
        minWidth: '25px',
        color: '#000',
        fontSize: '12px', 
    },

    invoiceParamValue: {
        fontSize: '12px',
        color: '#666',
    },


    
    tableBox: { 
        padding: '0 30px',
        marginTop: '30px',
    }, 
    
    table: { 
        display: "table", 
        width: "auto", 
        borderStyle: "solid", 
        borderWidth: 0,   
        borderColor: '#fff',

    }, 
    
    tableRow: {   
        flexDirection: "row",  
    }, 

    tableCol: {  
        width: "20%", 
        borderStyle: "solid", 
        borderWidth: 2, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
        borderColor: '#fff',
        backgroundColor: '#30343b',
        color: '#fff',
        padding: '10px',
        fontSize: 15,   
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'flex-start',  
        justifyContent: 'center'  
    },  
    tableCell: { 
        lineHeight: .9,
        margin: "0", 
        fontFamily: 'HelveticaBold' 
    },
     
 
    
    tableBoxResult: { 
        padding: '0 30px',
        marginTop: '10px',
    }, 
    
    tableResult: { 
        display: "table", 
        width: "auto", 
        borderStyle: "solid", 
        borderWidth: 0,   
        borderColor: '#fff',

    }, 
    
    tableRowResult: {   
        flexDirection: "row",  
    }, 

    tableColResult: {  
        width: "20%", 
        borderStyle: "solid", 
        borderWidth: 2, 
        borderLeftWidth: 0, 
        borderTopWidth: 0,
        borderColor: '#fff',
        border: '1px solid black',
        color: '#000',
        padding: '10px',
        fontSize: 14,   
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'flex-start',  
        justifyContent: 'center', 
        family: 'HelveticaBold', 
    }, 

    tableCellResult: { 
        lineHeight: .9,
        margin: "0",  
    },

    bankParam: {
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'flex-end',
        marginBottom: '4px',
    },

    bankParamText: {
        fontFamily: 'HelveticaBold',
        width: '60px',
        color: '#000',
        fontSize: '10px', 
    },

    bankParamValue: {
        fontSize: '10px',
        color: '#555',
    },
});

const MyDocument = ({ invoiceData, data, clientData }) => (
    <Document>

        <Page size="A4" style={styles.page}>
            <View style={styles.header}>

                <View style={styles.invoiceBox}>
                    <Image src={AigLogo} style={{height: 'auto',width: '113.5px'}} />
                </View>

                <View style={styles.invoiceDateAndId}>
                    <View style={styles.invoiceNumber}>
                        <Text style={styles.invoiceNumberText}>Invoice:</Text>
                        <Text style={styles.invoiceNumberIDText}>{invoiceData.booking_id}</Text>
                    </View>
                    <View style={styles.invoiceDate}> 
                        <Text style={styles.invoiceDateText}>Date:</Text>
                        <Text style={styles.invoiceDateIDText}>{formatDate(invoiceData.created_at)}</Text>
                    </View>
                </View>
            </View>

 
            <View style={styles.invoiceToCompany}>
                <View style={styles.invoiceToCompanyBG}>

                    <View style={styles.invoiceTo}>
                        <Text style={styles.invoiceToHeader}>Client:</Text>
                        <Text style={styles.invoiceToName}>{clientData.firstname} {clientData.lastname}</Text>

                        <View style={styles.invoiceParam}>
                            <Text style={styles.invoiceParamText}>ID:</Text>
                            <Text style={styles.invoiceParamValue}>{ clientData.personal }</Text>
                        </View>

                        <View style={styles.invoiceParam}>
                            <Text style={styles.invoiceParamText}>Ph:</Text>
                            <Text style={styles.invoiceParamValue}>{ clientData.mobile }</Text>
                        </View>
                    
                    </View>

 

                    <View style={styles.invoiceCompany}>
                        <Text style={styles.invoiceCompanyHeader}>Comapany:</Text>
                        <Text style={styles.invoiceCompanyName}>Auto Import Georgia LLC</Text>
                    
                        <View style={styles.invoiceParam}>
                            <Text style={styles.invoiceParamText}>ID:</Text>
                            <Text style={styles.invoiceParamValue}>406203120</Text>
                        </View>

                        <View style={styles.invoiceParam}>
                            <Text style={styles.invoiceParamText}>Ad:</Text>
                            <Text style={styles.invoiceParamValue}>Ts.Dadiani str. 123/125, Tbilisi</Text>
                        </View>

                        <View style={styles.invoiceParam}>
                            <Text style={styles.invoiceParamText}>Ph:</Text>
                            <Text style={styles.invoiceParamValue}>(+995) 591 24 60 60; 0322 11 12 13</Text>
                        </View>
                    </View>
                </View>
            </View>
                    
            <View style={styles.tableBox}> 
                <View style={styles.table}>  
                
                    <View style={styles.tableRow}> 
                        <View style={{ ...styles.tableCol, width: '35%' }}>
                            {
                                invoiceData.type_id == 2 ?
                                <Text style={styles.tableCell}>Truck Number</Text> 
                                :
                                <Text style={styles.tableCell}>Container Number</Text> 
                            } 
                        </View> 
                        <View style={{ ...styles.tableCol, width: '23%' }}> 
                            <Text style={styles.tableCell}>Container Fee</Text> 
                        </View> 
                        <View style={{ ...styles.tableCol, width: '25%' }}> 
                            <Text style={styles.tableCell}>THC/MH FEE</Text> 
                        </View> 
                        <View style={{ ...styles.tableCol, width: '17%' }}>
                            <Text style={styles.tableCell}>OTHER Fee</Text> 
                        </View>
                        
                    </View>

                </View>
            </View>
    
                <View style={styles.tableBoxResult}> 
                    <View style={styles.tableResult}>  

                        <View style={styles.tableRowResult}> 
                            <View style={{ ...styles.tableColResult, width: '35%' }}> 
                                <Text style={{...styles.tableCellResult}}>   
                                   {data.container_number} 
                                </Text> 
                            </View> 
                            <View style={{ ...styles.tableColResult, width: '23%' }}> 
                                <Text style={{...styles.tableCellResult, fontFamily: 'HelveticaBold',}}>
                                    {data.container_fee}                                
                                </Text> 
                            </View> 
                            <View style={{ ...styles.tableColResult, width: '25%' }}>                                 
                                <Text style={{...styles.tableCellResult, fontFamily: 'HelveticaBold',}}>
                                    {data.thc_mh_fee} 
                                </Text>
                            </View> 
                            <View style={{ ...styles.tableColResult, width: '17%' }}> 
                                <Text style={{...styles.tableCellResult, fontFamily: 'HelveticaBold',}}>
                                    {data.other_fee}
                                </Text> 
                            </View> 
                        
                        </View>
    
                    </View>
                </View>

            <View style={{marginLeft: 'auto', marginTop: '10px', marginBottom: '20px',marginRight: '30px'}}>
                <View>
                    <View style={{fontFamily: 'HelveticaBold', fontWeight: 'bold', fontSize: '14px', padding: '0' }}> 
                        <Text style={{ marginTop: '0px',}}>
                            TOTAL: {data.total_price}  
                        </Text> 
                    </View>  

                    <View style={{ 
                fontFamily: 'HelveticaBold', fontWeight: 'bold', fontSize: '14px', padding: '10px 20px', border:'3px solid #da0429'}}> 
                        <Text style={{ marginTop: '0px',}}>
                                Debit:          {data.debit}
                        </Text> 
                    </View>  
                </View>
            </View>

            <View style={{marginLeft: '30px', marginBottom: '20px', marginRight: '30px'}}>
                <View style={styles.tableRowResult}>
                    <View style={{ ...styles.tableColResult, width: '30%' }}> 
                            <Text style={{...styles.tableCellResult, fontFamily: 'HelveticaBold',}}>
                                Route                                
                            </Text> 
                    </View> 
                    <View style={{ ...styles.tableColResult, width: '100%' }}> 
                            <Text style={{...styles.tableCellResult, fontFamily: 'HelveticaBold',}}>
                                {invoiceData.sender_country.name} - {invoiceData.reciever_country.name}                        
                            </Text> 
                    </View> 
                </View>
                <View style={styles.tableRowResult}>
                    <View style={{ ...styles.tableColResult, width: '30%' }}> 
                            <Text style={{...styles.tableCellResult, fontFamily: 'HelveticaBold',}}>
                                Description                                
                            </Text> 
                    </View> 
                    <View style={{ ...styles.tableColResult, width: '100%' }}> 
                            <Text style={{...styles.tableCellResult, fontSize: '12px'}}>
                                {invoiceData.description}                             
                            </Text> 
                    </View> 
                </View>
            </View>
            
            <View style={{display: 'flex',flexDirection: "row", justifyContent: 'space-between', border: '2px solid #da0429', margin: '0 30px', padding:'10px', marginBottom: '20px'}}>
                <View>
                    <View style={styles.bankParam}>
                        <Text style={styles.bankParamText}>Bank Name</Text>
                        <Text style={styles.bankParamValue}>Bank of Georgia</Text>
                    </View>


                    <View style={styles.bankParam}>
                        <Text style={styles.bankParamText}>Bank Swift</Text>
                        <Text style={styles.bankParamValue}>BAGAGE22</Text>
                    </View>

                    <View style={styles.bankParam}>
                        <Text style={styles.bankParamText}>IBAN</Text>
                        <Text style={styles.bankParamValue}>GE60BG0000000604840029 GEL/USD</Text>
                    </View>
                </View>


                {/* <View>
                    <View style={styles.bankParam}>
                        <Text style={styles.bankParamText}>Bank Name</Text>
                        <Text style={styles.bankParamValue}>JSC TBC BANK</Text>
                    </View>


                    <View style={styles.bankParam}>
                        <Text style={styles.bankParamText}>Bank Swift</Text>
                        <Text style={styles.bankParamValue}>TBCBGE22</Text>
                    </View>

                    <View style={styles.bankParam}>
                        <Text style={styles.bankParamText}>IBAN</Text>
                        <Text style={styles.bankParamValue}>GE54TB7734536020100004 GEL</Text>
                    </View>
                </View> */}
            </View>

            <View style={{border: '2px solid #da0429', margin: '0 30px', padding:'10px', fontSize: '10px'}}>
                <Text>*დანიშნულებაში მიუთითეთ ავტოსატრანსპორტო საშუალების VIN კოდის ბოლო 6 ციფრი</Text>
                <Text>*ტრანსპორტირების თანხის გადახდა ხორციელდება ლარში, გადახდის დღეს არსებული ეროვნული ბანკის კურსით</Text>
            </View>
            

            
        </Page>


    </Document>
);

const Invoice = ({ booking, data, clientItem}) => {
  
    const generatePDF = async () => {
        console.log(booking)
        const blob = await pdf(<MyDocument invoiceData={booking} data ={data} clientData={clientItem} />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        // link.download = 'invoice.pdf';
        link.click();
    };
        
    return (<span className={cl.btn} onClick={generatePDF}> <Attachment /> ინვოისი </span>);
 
};

export default Invoice;
